// // import React, { useEffect, useRef } from "react";
// // import PropTypes from "prop-types";
// // import 'ol/ol.css';
// // import Map from 'ol/Map';
// // import View from 'ol/View';
// // import TileLayer from 'ol/layer/Tile';
// // import OSM from 'ol/source/OSM';
// // import Overlay from 'ol/Overlay';
// // import { Box, Paper, IconButton } from "@mui/material";
// // import AddIcon from "@mui/icons-material/Add";
// // import RemoveIcon from "@mui/icons-material/Remove";
// // import { Vector as VectorLayer } from 'ol/layer';
// // import { Vector as VectorSource } from 'ol/source';
// // import { Feature } from 'ol';
// // import { LineString, Point } from 'ol/geom';
// // import { Style, Stroke, Circle, Fill, Text } from 'ol/style';
// // import { fromLonLat } from 'ol/proj';
// // import polyline from '@mapbox/polyline';

// // export default function SimpleOpenLayersMap({ center = [74.2515, 16.7041], zoom = 10, journeys = [], selectedJourneys = {} }) {
// //   const mapRef = useRef(null);
// //   const overlayRef = useRef(null);
// //   const mapInstanceRef = useRef(null);
// //   const vectorLayerRef = useRef(null);

// //   // Define an array of colors for different journeys
// //   const journeyColors = [
// //     '#FF0000', // Red
// //     '#00FF00', // Green
// //     '#0000FF', // Blue
// //     '#FFA500', // Orange
// //     '#800080', // Purple
// //     '#008000', // Dark Green
// //   ];

// //   useEffect(() => {
// //     if (!mapRef.current) return;

// //     // Initialize map
// //     const tileLayer = new TileLayer({
// //       source: new OSM(),
// //     });

// //     const overlayEl = document.createElement('div');
// //     overlayEl.className = 'bg-white p-2 rounded shadow text-xs';
// //     overlayEl.style.minWidth = '120px';
// //     overlayEl.style.pointerEvents = 'none';
// //     overlayEl.innerText = '';

// //     overlayRef.current = new Overlay({
// //       element: overlayEl,
// //       positioning: 'bottom-center',
// //       stopEvent: false,
// //       offset: [0, -10],
// //     });

// //     const map = new Map({
// //       target: mapRef.current,
// //       layers: [tileLayer],
// //       overlays: [overlayRef.current],
// //       view: new View({
// //         center: fromLonLat(center),
// //         zoom,
// //       }),
// //       controls: [],
// //     });

// //     mapInstanceRef.current = map;

// //     // Initialize vector layer for routes and stops
// //     vectorLayerRef.current = new VectorLayer({
// //       source: new VectorSource(),
// //       style: (feature, resolution) => {
// //         const geometryType = feature.getGeometry().getType();
// //         if (geometryType === 'LineString') {
// //           const journeyId = feature.get('journeyId');
// //           const colorIndex = journeyId ? parseInt(journeyId.split('-')[0], 16) % journeyColors.length : 0;
// //           return new Style({
// //             stroke: new Stroke({
// //               color: journeyColors[colorIndex], // Unique color for each journey
// //               width: 3,
// //             }),
// //           });
// //         } else if (geometryType === 'Point') {
// //           const stopIndex = feature.get('stopIndex');
// //           return new Style({
// //             image: new Circle({
// //               radius: 10,
// //               fill: new Fill({ color: '#000000' }), // Black for stops
// //               stroke: new Stroke({ color: '#FFFFFF', width: 2 }),
// //             }),
// //             text: new Text({
// //               text: stopIndex !== undefined ? stopIndex.toString() : '', // Number inside marker
// //               font: '12px sans-serif',
// //               fill: new Fill({ color: '#FFFFFF' }), // White text for contrast
// //               stroke: new Stroke({ color: '#000000', width: 2 }),
// //               offsetY: 0, // Center the number inside the marker
// //             }),
// //           });
// //         }
// //         return null;
// //       },
// //     });
// //     map.addLayer(vectorLayerRef.current);

// //     map.on('singleclick', (evt) => {
// //       const coord = evt.coordinate;
// //       const toLonLat = (c) => {
// //         const x = (c[0] / 20037508.34) * 180;
// //         let y = (c[1] / 20037508.34) * 180;
// //         y = (180 / Math.PI) * (2 * Math.atan(Math.exp((y * Math.PI) / 180)) - Math.PI / 2);
// //         return [Number(x.toFixed(6)), Number(y.toFixed(6))];
// //       };

// //       const [lon, lat] = toLonLat(coord);
// //       overlayRef.current.getElement().innerText = `Lon: ${lon}\nLat: ${lat}`;
// //       overlayRef.current.setPosition(coord);
// //     });

// //     const handleResize = () => map.updateSize();
// //     window.addEventListener('resize', handleResize);

// //     return () => {
// //       window.removeEventListener('resize', handleResize);
// //       map.setTarget(null);
// //     };
// //   }, [center, zoom]);

// //   // Update routes and stops when selectedJourneys change
// //   useEffect(() => {
// //     if (!mapInstanceRef.current || !vectorLayerRef.current) return;

// //     const source = vectorLayerRef.current.getSource();
// //     source.clear(); // Clear existing features

// //     // Filter selected journeys
// //     const selectedJourneyIds = Object.keys(selectedJourneys).filter((id) => selectedJourneys[id]);
// //     const selectedJourneysData = journeys.filter((journey) => selectedJourneyIds.includes(journey.journeyId));

// //     // Plot only selected journeys
// //     selectedJourneysData.forEach((journey, journeyIndex) => {
// //       // Decode polyline and add route
// //       try {
// //         const decodedCoords = polyline.decode(journey.encodedPath);
// //         const routeCoords = decodedCoords.map(([lat, lon]) => fromLonLat([lon, lat]));
// //         const routeFeature = new Feature({
// //           geometry: new LineString(routeCoords),
// //           journeyId: journey.journeyId, // Store journeyId for color assignment
// //         });
// //         source.addFeature(routeFeature);
// //       } catch (error) {
// //         console.error("Error decoding polyline for journey", journey.journeyId, error);
// //       }

// //       // Add stop points as markers with numbers
// //       journey.stopPoints.forEach((stop, stopIndex) => {
// //         const { latitude, longitude } = stop.location;
// //         const stopFeature = new Feature({
// //           geometry: new Point(fromLonLat([longitude, latitude])),
// //           name: stop.locationName,
// //           stopIndex: (stopIndex + 1).toString(), // Number the stops starting from 1
// //         });
// //         source.addFeature(stopFeature);
// //       });

// //       // Update overlay with selected journey details
// //       const overlayEl = overlayRef.current.getElement();
// //       overlayEl.innerText = `Route: ${journey.journeyName} ${journey.type} (${journey.interval.startTime}-${journey.interval.endTime})\nStops:`;
// //       journey.stopPoints.forEach((stop, index) => {
// //         overlayEl.innerText += `\n${index + 1}: ${stop.locationName}`;
// //       });
// //     });

// //     // Adjust map view to fit all selected routes and stops
// //     if (selectedJourneysData.length > 0) {
// //       const extent = source.getExtent();
// //       if (!isFinite(extent[0])) return; // Skip if extent is invalid
// //       mapInstanceRef.current.getView().fit(extent, {
// //         padding: [50, 50, 50, 50],
// //         maxZoom: 15,
// //       });
// //     } else {
// //       overlayRef.current.getElement().innerText = '';
// //     }
// //   }, [journeys, selectedJourneys]);

// //   const handleZoomIn = () => {
// //     if (mapInstanceRef.current) {
// //       mapInstanceRef.current.getView().setZoom(mapInstanceRef.current.getView().getZoom() + 1);
// //     }
// //   };

// //   const handleZoomOut = () => {
// //     if (mapInstanceRef.current) {
// //       mapInstanceRef.current.getView().setZoom(mapInstanceRef.current.getView().getZoom() - 1);
// //     }
// //   };

// //   return (
// //     <Paper elevation={3} sx={{ position: "relative", width: "100%", height: 480, borderRadius: 2, overflow: "hidden" }}>
// //       <Box ref={mapRef} sx={{ width: "100%", height: "100%" }} />
// //       <Box sx={{ position: "absolute", top: 16, left: 16, display: "flex", flexDirection: "column", gap: 1 }}>
// //         <IconButton size="small" color="primary" onClick={handleZoomIn} sx={{ bgcolor: "white" }}>
// //           <AddIcon />
// //         </IconButton>
// //         <IconButton size="small" color="primary" onClick={handleZoomOut} sx={{ bgcolor: "white" }}>
// //           <RemoveIcon />
// //         </IconButton>
// //       </Box>
// //     </Paper>
// //   );
// // }

// // SimpleOpenLayersMap.propTypes = {
// //   center: PropTypes.arrayOf(PropTypes.number),
// //   zoom: PropTypes.number,
// //   journeys: PropTypes.arrayOf(
// //     PropTypes.shape({
// //       journeyId: PropTypes.string,
// //       journeyName: PropTypes.string,
// //       type: PropTypes.string,
// //       interval: PropTypes.shape({
// //         startTime: PropTypes.string,
// //         endTime: PropTypes.string,
// //       }),
// //       encodedPath: PropTypes.string,
// //       stopPoints: PropTypes.arrayOf(
// //         PropTypes.shape({
// //           locationName: PropTypes.string,
// //           location: PropTypes.shape({
// //             latitude: PropTypes.number,
// //             longitude: PropTypes.number,
// //           }),
// //         })
// //       ),
// //     })
// //   ),
// //   selectedJourneys: PropTypes.object,
// // };

// // SimpleOpenLayersMap.defaultProps = {
// //   center: [74.2515, 16.7041], // Approximate center for Kolhapur, Maharashtra
// //   zoom: 10,
// //   journeys: [],
// //   selectedJourneys: {},
// // };
// import React, { useEffect, useRef } from "react";
// import PropTypes from "prop-types";
// import 'ol/ol.css';
// import Map from 'ol/Map';
// import View from 'ol/View';
// import TileLayer from 'ol/layer/Tile';
// import OSM from 'ol/source/OSM';
// import { Box, Paper, IconButton } from "@mui/material";
// import AddIcon from "@mui/icons-material/Add";
// import RemoveIcon from "@mui/icons-material/Remove";
// import { Vector as VectorLayer } from 'ol/layer';
// import { Vector as VectorSource } from 'ol/source';
// import { Feature } from 'ol';
// import { LineString, Point } from 'ol/geom';
// import { Style, Stroke, Circle, Fill, Text } from 'ol/style';
// import { fromLonLat } from 'ol/proj';
// import polyline from '@mapbox/polyline';

// export default function SimpleOpenLayersMap({ center = [74.2515, 16.7041], zoom = 10, journeys = [], selectedJourneys = {} }) {
//   const mapRef = useRef(null);
//   const mapInstanceRef = useRef(null);
//   const vectorLayerRef = useRef(null);

//   // Define an array of colors for different journeys
//   const journeyColors = [
//     '#FF0000', // Red
//     '#00FF00', // Green
//     '#0000FF', // Blue
//     '#FFA500', // Orange
//     '#800080', // Purple
//     '#008000', // Dark Green
//   ];

//   useEffect(() => {
//     if (!mapRef.current) return;

//     // Initialize map
//     const tileLayer = new TileLayer({
//       source: new OSM(),
//     });

//     const map = new Map({
//       target: mapRef.current,
//       layers: [tileLayer],
//       view: new View({
//         center: fromLonLat(center),
//         zoom,
//       }),
//       controls: [],
//     });

//     mapInstanceRef.current = map;

//     // Initialize vector layer for routes and stops
//     vectorLayerRef.current = new VectorLayer({
//       source: new VectorSource(),
//       style: (feature, resolution) => {
//         const geometryType = feature.getGeometry().getType();
//         if (geometryType === 'LineString') {
//           const journeyId = feature.get('journeyId');
//           const colorIndex = journeyId ? parseInt(journeyId.split('-')[0], 16) % journeyColors.length : 0;
//           return new Style({
//             stroke: new Stroke({
//               color: journeyColors[colorIndex], // Unique color for each journey
//               width: 3,
//             }),
//           });
//         } else if (geometryType === 'Point') {
//           const stopIndex = feature.get('stopIndex');
//           return new Style({
//             image: new Circle({
//               radius: 10,
//               fill: new Fill({ color: '#000000' }), // Black for stops
//               stroke: new Stroke({ color: '#FFFFFF', width: 2 }),
//             }),
//             text: new Text({
//               text: stopIndex !== undefined ? stopIndex.toString() : '', // Number inside marker
//               font: '12px sans-serif',
//               fill: new Fill({ color: '#FFFFFF' }), // White text for contrast
//               stroke: new Stroke({ color: '#000000', width: 2 }),
//               offsetY: 0, // Center the number inside the marker
//             }),
//           });
//         }
//         return null;
//       },
//     });
//     map.addLayer(vectorLayerRef.current);

//     const handleResize = () => map.updateSize();
//     window.addEventListener('resize', handleResize);

//     return () => {
//       window.removeEventListener('resize', handleResize);
//       map.setTarget(null);
//     };
//   }, [center, zoom]);

//   // Update routes and stops when selectedJourneys change
//   useEffect(() => {
//     if (!mapInstanceRef.current || !vectorLayerRef.current) return;

//     const source = vectorLayerRef.current.getSource();
//     source.clear(); // Clear existing features

//     // Filter selected journeys
//     const selectedJourneyIds = Object.keys(selectedJourneys).filter((id) => selectedJourneys[id]);
//     const selectedJourneysData = journeys.filter((journey) => selectedJourneyIds.includes(journey.journeyId));

//     // Plot only selected journeys
//     selectedJourneysData.forEach((journey) => {
//       // Decode polyline and add route
//       try {
//         const decodedCoords = polyline.decode(journey.encodedPath);
//         const routeCoords = decodedCoords.map(([lat, lon]) => fromLonLat([lon, lat]));
//         const routeFeature = new Feature({
//           geometry: new LineString(routeCoords),
//           journeyId: journey.journeyId, // Store journeyId for color assignment
//         });
//         source.addFeature(routeFeature);
//       } catch (error) {
//         console.error("Error decoding polyline for journey", journey.journeyId, error);
//       }

//       // Add stop points as markers with numbers
//       journey.stopPoints.forEach((stop, stopIndex) => {
//         const { latitude, longitude } = stop.location;
//         const stopFeature = new Feature({
//           geometry: new Point(fromLonLat([longitude, latitude])),
//           name: stop.locationName,
//           stopIndex: (stopIndex + 1).toString(), // Number the stops starting from 1
//         });
//         source.addFeature(stopFeature);
//       });
//     });

//     // Adjust map view to fit all selected routes and stops
//     if (selectedJourneysData.length > 0) {
//       const extent = source.getExtent();
//       if (!isFinite(extent[0])) return; // Skip if extent is invalid
//       mapInstanceRef.current.getView().fit(extent, {
//         padding: [50, 50, 50, 50],
//         maxZoom: 15,
//       });
//     }
//   }, [journeys, selectedJourneys]);

//   const handleZoomIn = () => {
//     if (mapInstanceRef.current) {
//       mapInstanceRef.current.getView().setZoom(mapInstanceRef.current.getView().getZoom() + 1);
//     }
//   };

//   const handleZoomOut = () => {
//     if (mapInstanceRef.current) {
//       mapInstanceRef.current.getView().setZoom(mapInstanceRef.current.getView().getZoom() - 1);
//     }
//   };

//   return (
//     <Paper elevation={3} sx={{ position: "relative", width: "100%", height: 480, borderRadius: 2, overflow: "hidden" }}>
//       <Box ref={mapRef} sx={{ width: "100%", height: "100%" }} />
//       <Box sx={{ position: "absolute", top: 16, left: 16, display: "flex", flexDirection: "column", gap: 1 }}>
//         <IconButton size="small" color="primary" onClick={handleZoomIn} sx={{ bgcolor: "white" }}>
//           <AddIcon />
//         </IconButton>
//         <IconButton size="small" color="primary" onClick={handleZoomOut} sx={{ bgcolor: "white" }}>
//           <RemoveIcon />
//         </IconButton>
//       </Box>
//     </Paper>
//   );
// }

// SimpleOpenLayersMap.propTypes = {
//   center: PropTypes.arrayOf(PropTypes.number),
//   zoom: PropTypes.number,
//   journeys: PropTypes.arrayOf(
//     PropTypes.shape({
//       journeyId: PropTypes.string,
//       journeyName: PropTypes.string,
//       type: PropTypes.string,
//       interval: PropTypes.shape({
//         startTime: PropTypes.string,
//         endTime: PropTypes.string,
//       }),
//       encodedPath: PropTypes.string,
//       stopPoints: PropTypes.arrayOf(
//         PropTypes.shape({
//           locationName: PropTypes.string,
//           location: PropTypes.shape({
//             latitude: PropTypes.number,
//             longitude: PropTypes.number,
//           }),
//         })
//       ),
//     })
//   ),
//   selectedJourneys: PropTypes.object,
// };

// SimpleOpenLayersMap.defaultProps = {
//   center: [74.2515, 16.7041], // Approximate center for Kolhapur, Maharashtra
//   zoom: 10,
//   journeys: [],
//   selectedJourneys: {},
// };

import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import 'ol/ol.css';
import Map from 'ol/Map';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import Overlay from 'ol/Overlay';
import { Box, Paper, IconButton, CircularProgress } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import DownloadIcon from "@mui/icons-material/Download";
import LabelIcon from "@mui/icons-material/Label";
import LabelOffIcon from "@mui/icons-material/LabelOff";
import { Vector as VectorLayer } from 'ol/layer';
import { Vector as VectorSource } from 'ol/source';
import { Feature } from 'ol';
import { LineString, Point } from 'ol/geom';
import { Style, Stroke, Circle, Fill, Text as OlText } from 'ol/style';
import { fromLonLat } from 'ol/proj';
import polyline from '@mapbox/polyline';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export default function SimpleOpenLayersMap({ center = [74.2515, 16.7041], zoom = 10, journeys = [], selectedJourneys = {} }) {
  const mapRef = useRef(null);
  const containerRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const vectorLayerRef = useRef(null);
  const overlaysRef = useRef([]);

  const [isFullscreen, setIsFullscreen] = useState(false);
  const [showLabels, setShowLabels] = useState(true);
  const showLabelsRef = useRef(showLabels);
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    showLabelsRef.current = showLabels;
    overlaysRef.current.forEach((overlay) => {
      const element = overlay.getElement();
      if (element) {
        element.style.display = showLabels ? 'block' : 'none';
      }
    });
  }, [showLabels]);

  const journeyColors = [
    '#FF0000', '#00FF00', '#0000FF', '#FFA500', '#800080', '#008000'
  ];

  const getJourneyColor = (journeyId) => {
    const index = journeys.findIndex((j) => j.journeyId === journeyId);
    return journeyColors[Math.max(0, index) % journeyColors.length];
  };

  const hexToRgb = (hex) => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? { r: parseInt(result[1], 16), g: parseInt(result[2], 16), b: parseInt(result[3], 16) } : { r: 0, g: 0, b: 0 };
  };

  useEffect(() => {
    if (!mapRef.current) return;

    const tileLayer = new TileLayer({
      source: new OSM({
        crossOrigin: 'anonymous'
      }),
    });

    const map = new Map({
      target: mapRef.current,
      layers: [tileLayer],
      view: new View({
        center: fromLonLat(center),
        zoom,
      }),
      controls: [], 
    });

    mapInstanceRef.current = map;

    vectorLayerRef.current = new VectorLayer({
      source: new VectorSource(),
      style: (feature) => {
        const geometryType = feature.getGeometry().getType();
        
        if (geometryType === 'LineString') {
          // Read absolute color assigned during feature creation
          const routeColor = feature.get('routeColor') || '#FF0000';
          return new Style({
            stroke: new Stroke({
              color: routeColor,
              width: 3,
            }),
          });
        } 
        else if (geometryType === 'Point') {
          const stopIndex = feature.get('stopIndex');
          return new Style({
            image: new Circle({
              radius: 10,
              fill: new Fill({ color: '#333333' }), 
              stroke: new Stroke({ color: '#FFFFFF', width: 2 }),
            }),
            text: new OlText({
              text: stopIndex !== undefined ? stopIndex.toString() : '',
              font: 'bold 11px sans-serif',
              fill: new Fill({ color: '#FFFFFF' }),
              offsetY: 0,
            }),
          });
        }
        return null;
      },
    });
    map.addLayer(vectorLayerRef.current);

    const handleResize = () => map.updateSize();
    window.addEventListener('resize', handleResize);

    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
      setTimeout(() => map.updateSize(), 200); 
    };
    document.addEventListener("fullscreenchange", handleFullscreenChange);

    return () => {
      window.removeEventListener('resize', handleResize);
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      map.setTarget(null);
    };
  }, [center, zoom]);

  useEffect(() => {
    if (!mapInstanceRef.current || !vectorLayerRef.current) return;

    const source = vectorLayerRef.current.getSource();
    source.clear();

    overlaysRef.current.forEach(overlay => {
      mapInstanceRef.current.removeOverlay(overlay);
    });
    overlaysRef.current = [];

    const selectedJourneyIds = Object.keys(selectedJourneys).filter((id) => selectedJourneys[id]);
    const selectedJourneysData = journeys.filter((journey) => selectedJourneyIds.includes(journey.journeyId));

    selectedJourneysData.forEach((journey) => {
      // Get fixed matching color
      const routeColor = getJourneyColor(journey.journeyId);

      try {
        const decodedCoords = polyline.decode(journey.encodedPath);
        const routeCoords = decodedCoords.map(([lat, lon]) => fromLonLat([lon, lat]));
        const routeFeature = new Feature({
          geometry: new LineString(routeCoords),
          journeyId: journey.journeyId,
          routeColor: routeColor, // Assing property exactly here
        });
        source.addFeature(routeFeature);
      } catch (error) {
        console.error("Error decoding polyline for journey", journey.journeyId, error);
      }

      journey.stopPoints.forEach((stop, stopIndex) => {
        const { latitude, longitude } = stop.location;
        const coords = fromLonLat([longitude, latitude]);

        const stopFeature = new Feature({
          geometry: new Point(coords),
          stopIndex: (stopIndex + 1).toString(),
        });
        source.addFeature(stopFeature);

        const overlayElement = document.createElement('div');
        overlayElement.className = 'custom-map-tooltip';
        overlayElement.innerText = stop.locationName;
        overlayElement.style.display = showLabelsRef.current ? 'block' : 'none';

        const overlay = new Overlay({
          element: overlayElement,
          position: coords,
          positioning: 'bottom-center',
          offset: [0, -14],
          stopEvent: false, 
        });

        mapInstanceRef.current.addOverlay(overlay);
        overlaysRef.current.push(overlay);
      });
    });

    if (selectedJourneysData.length > 0) {
      const extent = source.getExtent();
      if (!isFinite(extent[0])) return;
      mapInstanceRef.current.getView().fit(extent, {
        padding: [50, 50, 50, 50],
        maxZoom: 15,
      });
    }
  }, [journeys, selectedJourneys]);

  const handleZoomIn = () => {
    if (mapInstanceRef.current) {
      mapInstanceRef.current.getView().setZoom(mapInstanceRef.current.getView().getZoom() + 1);
    }
  };

  const handleZoomOut = () => {
    if (mapInstanceRef.current) {
      mapInstanceRef.current.getView().setZoom(mapInstanceRef.current.getView().getZoom() - 1);
    }
  };

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      containerRef.current.requestFullscreen().catch((err) => {
        console.error(`Error attempting to enable full-screen mode: ${err.message}`);
      });
    } else {
      document.exitFullscreen();
    }
  };

  const toggleLabels = () => {
    setShowLabels(!showLabels);
  };

  const downloadAsPDF = async () => {
    setIsDownloading(true);
    try {
      const mapElement = mapRef.current;
      mapInstanceRef.current.renderSync(); 

      const canvas = await html2canvas(mapElement, {
        useCORS: true,
        allowTaint: false,
        logging: false
      });

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
      
      pdf.text("Map Overview", 10, 10);
      pdf.addImage(imgData, "PNG", 0, 15, pdfWidth, pdfHeight);

      let currentY = 15 + pdfHeight + 10;
      pdf.setFontSize(12);
      
      const selectedJourneyIds = Object.keys(selectedJourneys).filter(id => selectedJourneys[id]);
      const selectedJourneysData = journeys.filter(j => selectedJourneyIds.includes(j.journeyId));

      if (selectedJourneysData.length === 0) {
        pdf.text("No routes selected.", 10, currentY);
      }

      selectedJourneysData.forEach((journey) => {
        if (currentY > 280) {
          pdf.addPage();
          currentY = 20;
        }

        // Apply 100% matched RGB color to PDF route heading
        const routeColorHex = getJourneyColor(journey.journeyId);
        const { r, g, b } = hexToRgb(routeColorHex);
        
        pdf.setTextColor(r, g, b);
        pdf.setFont(undefined, "bold");
        pdf.text(`Route: ${journey.journeyName} (${journey.interval.startTime} - ${journey.interval.endTime})`, 10, currentY);
        currentY += 7;

        // Reset text color to black for stops
        pdf.setTextColor(0, 0, 0);
        pdf.setFont(undefined, "normal");
        
        journey.stopPoints.forEach((stop, idx) => {
          if (currentY > 280) {
            pdf.addPage();
            currentY = 20;
          }
          pdf.text(`${idx + 1}. ${stop.locationName}`, 15, currentY);
          currentY += 6;
        });
        currentY += 5; 
      });

      pdf.save("Catchemnt_map.pdf");
    } catch (error) {
      console.error("Error generating PDF:", error);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <>
      <style>{`
        .custom-map-tooltip {
          position: relative;
          background: #ffffff;
          border-radius: 6px;
          padding: 6px 10px;
          border: 1px solid #999999;
          box-shadow: 0px 3px 6px rgba(0,0,0,0.15);
          font-size: 13px;
          font-family: sans-serif;
          font-weight: 500;
          color: #333333;
          white-space: nowrap;
          pointer-events: none;
          z-index: 10;
        }
        .custom-map-tooltip::after, .custom-map-tooltip::before {
          top: 100%;
          left: 50%;
          border: solid transparent;
          content: " ";
          height: 0;
          width: 0;
          position: absolute;
          pointer-events: none;
        }
        .custom-map-tooltip::after {
          border-color: rgba(255, 255, 255, 0);
          border-top-color: #ffffff;
          border-width: 6px;
          margin-left: -6px;
        }
        .custom-map-tooltip::before {
          border-color: rgba(153, 153, 153, 0);
          border-top-color: #999999;
          border-width: 7px;
          margin-left: -7px;
        }
      `}</style>

      <Paper 
        ref={containerRef} 
        elevation={3} 
        sx={{ 
          position: "relative", 
          width: "100%", 
          height: isFullscreen ? "100vh" : 500, 
          borderRadius: isFullscreen ? 0 : 2, 
          overflow: "hidden",
          backgroundColor: "#f5f5f5"
        }}
      >
        <Box ref={mapRef} sx={{ width: "100%", height: "100%" }} />

        <Box sx={{ position: "absolute", top: 16, left: 16, display: "flex", flexDirection: "column", gap: 1 }}>
          <IconButton size="small" color="primary" onClick={handleZoomIn} sx={{ bgcolor: "white", boxShadow: 1, "&:hover": { bgcolor: "#f0f0f0" } }}>
            <AddIcon />
          </IconButton>
          <IconButton size="small" color="primary" onClick={handleZoomOut} sx={{ bgcolor: "white", boxShadow: 1, "&:hover": { bgcolor: "#f0f0f0" } }}>
            <RemoveIcon />
          </IconButton>
        </Box>

        <Box sx={{ position: "absolute", top: 16, right: 16, display: "flex", flexDirection: "column", gap: 1 }}>
          <IconButton size="small" color="primary" onClick={toggleFullscreen} sx={{ bgcolor: "white", boxShadow: 1, "&:hover": { bgcolor: "#f0f0f0" } }} title="Toggle Fullscreen">
            {isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
          </IconButton>
          
          <IconButton size="small" color="primary" onClick={toggleLabels} sx={{ bgcolor: "white", boxShadow: 1, "&:hover": { bgcolor: "#f0f0f0" } }} title="Toggle Labels">
            {showLabels ? <LabelIcon /> : <LabelOffIcon />}
          </IconButton>

          <IconButton size="small" color="primary" onClick={downloadAsPDF} disabled={isDownloading} sx={{ bgcolor: "white", boxShadow: 1, "&:hover": { bgcolor: "#f0f0f0" } }} title="Download as PDF">
            {isDownloading ? <CircularProgress size={20} /> : <DownloadIcon />}
          </IconButton>
        </Box>
      </Paper>
    </>
  );
}

SimpleOpenLayersMap.propTypes = {
  center: PropTypes.arrayOf(PropTypes.number),
  zoom: PropTypes.number,
  journeys: PropTypes.arrayOf(
    PropTypes.shape({
      journeyId: PropTypes.string,
      journeyName: PropTypes.string,
      type: PropTypes.string,
      interval: PropTypes.shape({
        startTime: PropTypes.string,
        endTime: PropTypes.string,
      }),
      encodedPath: PropTypes.string,
      stopPoints: PropTypes.arrayOf(
        PropTypes.shape({
          locationName: PropTypes.string,
          location: PropTypes.shape({
            latitude: PropTypes.number,
            longitude: PropTypes.number,
          }),
        })
      ),
    })
  ),
  selectedJourneys: PropTypes.object,
};

SimpleOpenLayersMap.defaultProps = {
  center: [74.2515, 16.7041], 
  zoom: 10,
  journeys: [],
  selectedJourneys: {},
};